import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../service/authentication.service';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.css'],
  providers: [AuthenticationService],
})
export class EmployeesComponent implements OnInit {
  constructor(private authorizationService: AuthenticationService) {
    this.authorizationService.getSales().subscribe((res) => {
      //console.log(res)
      res.map((item) => {
        console.log(item.payload.val());
      });
    });
  }

  ngOnInit(): void {}
}
